/**
 * Created by Shen Mo on 2018/7/16
 *
 * Wrapped core/ajax HTTP request.
 * process global error data.
 *
 */
import * as _ from 'lodash-es';

import Modal from '@core/component/portal/Modal';
import ajax, { ERROR_CODE } from '@core/utils/ajax';
import fileDownload from '@core/utils/fileDownload';

import { modalGlobalTipsName } from '@/libs/GlobalTips';

const EMPTY_RES = {};

const _preProcessor = (url, options = {}, response) => {
	if (process.env.NODE_ENV !== 'production') {
		console.log(`[${url}]:`, response);
	}
	if (response.error) {
		if (
			!options.disabledErrorList ||
			(_.isArray(options.disabledErrorList) &&
				options.disabledErrorList.indexOf(-2) === -1 &&
				options.disabledErrorList.indexOf(-4) === -1)
		) {
			if (response.error === ERROR_CODE.FETCH_ABORT) {
			} else if (response.error === ERROR_CODE.FETCH_TIMEOUT) {
				Modal.show(modalGlobalTipsName, { r: -4 }).then((res) => {
					// TODO: resend logic!
					if (res) {
						return request(url, options);
					}
				});
			} else {
				Modal.show(modalGlobalTipsName, { r: -2 });
			}
		}
		return EMPTY_RES;
	} else {
		if (response.res && response.res.r !== 0) {
			switch (response.res.r) {
				default: {
					if (
						!options.disabledErrorList ||
						(_.isArray(options.disabledErrorList) && options.disabledErrorList.indexOf(response.res.r) === -1)
					) {
						Modal.show(modalGlobalTipsName, response.res);
					}
				}
			}
		}
		return response.res;
	}
};

export const download = (url, options) => {
	const { name, mime, ...opt } = options;
	return fileDownload(url, name, mime, opt).then((response) => {
		if (_.isPlainObject(response)) {
			return _preProcessor(url, opt, response);
		} else {
			return { r: 0 };
		}
	});
};

function request(url, options) {
	return ajax(url, options || {}).then((response) => {
		return _preProcessor(url, options, response);
	});
}

export default request;

if (!window._env) {
	window._env = {};
}
window._env.request = request;
